import {AxiosResponse} from "axios";
import * as React from "react";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import {HttpError} from "../../../../../common/components/shared/httpError/httpError";
import {Popup} from "../../../../../common/components/shared/popup/popup";
import {DropDownModel} from "../../../../../common/models/dropDown";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";
import {DropDownUtils} from "../../../../../helpers/dropDownUtils";
import {ValidatedValue} from "../../../../../helpers/validatedValue";
import i18n from "../../../../../i18n/i18n";
import {ReactComponent as AllowIcon} from "../../../../../statics/icons/icon_entryOrExitAllowPopup.svg";
import {LocationDropDownEntryModel} from "../../../../../topology/models/location";
import {TransportationService} from "../../../../services/transportationService";
import "./allowWithLocationDepoPopup.scss";

interface AllowWithLocationDepoPopupProps {
    orderId: string;
    selectedLocation: ValidatedValue<string>;
    onChangeDropdown: (newValue: any) => void;
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface AllowWithLocationDepoPopupState {
    locations: LocationDropDownEntryModel[];
    locationsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class AllowWithLocationDepoPopup extends React.Component <AllowWithLocationDepoPopupProps, AllowWithLocationDepoPopupState> {
    constructor(props: any) {
        super(props);

        this.state = {
            locations: [],
            locationsResponse: undefined
        };
    }

    async componentDidMount() {
        const locationsResponse = await TransportationService.getParkingLocationsForDropDown();

        this.setState({
            locations: (Api.isSuccess(locationsResponse) && locationsResponse.data) ? locationsResponse.data : [],
            locationsResponse
        });
    }

    public render(): JSX.Element {
        return (
            <Popup
                open={this.props.displayPopup}
                className="allow-with-location-depo-popup"
                header={i18n.t("transportation.order.status.allowWithLocationDepoPopup.header")}
                secondHeader={i18n.t("transportation.order.status.allowWithLocationDepoPopup.header")}
                icon={<AllowIcon/>}
                content={this.renderPopupContent()}
                actionText={i18n.t("transportation.order.status.allowWithLocationDepoPopup.actionText")}
                action={this.props.confirm}
                cancel={this.props.closePopup}
                testId="allow-with-location-depo-popup"
                httpError={
                    <>
                        {!Api.isSuccess(this.props.response) && (
                            <HttpError
                                response={this.props.response}
                                cause={i18n.t("transportation.order.status.allowErrorSuffix")}
                            />
                        )}
                        {!Api.isSuccess(this.state.locationsResponse) && (
                            <HttpError
                                response={this.state.locationsResponse}
                                cause={i18n.t("transportation.order.status.locationsErrorSuffix")}
                            />
                        )}
                    </>
                }
            />
        );
    }

    private renderPopupContent() {
        return (
            <div className="allow-with-location-depo-popup-content">
                {i18n.t("transportation.order.status.allowWithLocationDepoPopup.content")} <b>{this.props.orderId}</b>?
                <DropDown
                    className="selected-location"
                    label={i18n.t("transportation.order.status.allowWithLocationDepoPopup.label")}
                    validatedValue={this.props.selectedLocation}
                    items={this.locationsToDropDownMap()}
                    testId="allow-location"
                    onChange={this.props.onChangeDropdown}
                />
            </div>
        );
    }

    private locationsToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.locations, "id");
    }
}
